.info {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
}

.warning {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 200, 0, 0.1);
  border: 1px solid rgba(255, 200, 0, 0.35);
  box-sizing: border-box;
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
  box-sizing: border-box;
}

.mono {
  font-family: monospace;
  word-break: break-all;
}
